module.exports = __webpack_public_path__ + "static/img/dan-advance-logo.5129271.svg";


//////////////////
// WEBPACK FOOTER
// ./static/images/dan-advance-logo.svg
// module id = IXMF
// module chunks = 1